import CustomInputs from '../../common/Inputs';
import { GetImages } from '../../../utils/GetImages';
import { useError } from '../../../utils/context/ErrorContext';
import { useOnboardingContext } from '../../../utils/context/OnboardingContext';
import { FORM_CONTROLFIELD_TYPES } from '../../../constants/constants';
import SimpleButton from '../../../newComponents/buttons/Simple-button';
import Checkbox from '../../../newComponents/form-fields/checkbox';
import DateHelper from '../../../utils/DateHelper';

const SignatureCard = ({
  clause,
  formData,
  setFormData,
  editable,
  handleChange,
  isPreview = false,
  landlordEdit = undefined,
  handleClick = () => { },
  displayText = undefined,
  displayCheckbox = true,
  buttonName = "Sign Application"

}) => {
  const { errors, setErrors, errorMessages, setErrorMessages } = useError()
  const { isSignatureConfirm, setIsSignatureConfirm } = useOnboardingContext();
  const { fullName, signedDateTime } = formData || {};
  const isRole = fullName === "Landlord" || fullName === "Tenant";

  return (
    <div id="signature-section" className={landlordEdit ? 'signature-card-input-landlord' : 'signature-card-input'}>
      {((!isPreview && editable)) ? (
        <div className="signature-card">
          {displayCheckbox && (
            <div className='signature_checkbox px-3 py-2'>
              <Checkbox
                onChange={() => {
                  setIsSignatureConfirm(!isSignatureConfirm);
                  setErrors((prev) => ({ ...prev, isSignatureConfirm: false }));
                  setErrorMessages((prev) => ({ ...prev, isSignatureConfirm: "" }));
                }}
                isChecked={isSignatureConfirm}
                label="I confirm that the information provided above is true and based on my personal knowledge. I give my consent to share or use this information as needed." />
              {errors.isSignatureConfirm && (
                <p className="errorMessageStyles py-1 px-1">{errorMessages.isSignatureConfirm}</p>
              )}

            </div>
          )}
          <div className="authority_form signature-sign">
            <CustomInputs
              name="fullName"
              type={FORM_CONTROLFIELD_TYPES.TEXT}
              value={formData?.fullName == "Landlord" || formData?.fullName == "Tenant" ? "" : formData?.fullName}
              labelText={landlordEdit ? "Landlord Signature" : "Your Signature"}
              isFormControl={true}
              onChange={handleChange}
              // onChange={(e) => onChange(e.target.name, e.target.value)}
              placeholder={"Type your name"}
              myClassName={"containerTextField"}
              isError={errors.fullName}
              isRequired={true}
              requiredMessage="Full Name is required"
              errorMessages={errorMessages.fullName}
              width="260px"
            />

          </div>
          <div>
            <div className='p-2'>
              <SimpleButton type='button' label={buttonName} onClick={handleClick} />
            </div>
          </div>
        </div>
      ) : null}

      <div>

        {(fullName && (isPreview ? !!signedDateTime : !editable)) && (
          <div className="authority_form p-0">
            <div className="flexColumn">
              {displayText && (
                <div className='signature_checkbox p-3'>
                  I confirm that the information provided above is true and based on my personal knowledge. I give my consent to share or use this information as needed.
                </div>)}
              <div className='p-3 d-flex flex-column gap-2'>
                <div className="d-flex gap-1 ">
                  <div className='icon-wrapper'>
                    <img className="color-white-icon" src={GetImages.Signed} alt="Signature" />
                  </div>
                  <p className="signature">{isRole ? "" : fullName}</p>
                </div>
                {formData?.signedDateTime != null && (
                  <div className="">
                      <p className="normal_text black w-100">
                        Date Signed : {DateHelper.formatISOToMMDDYYYYTime(signedDateTime)}
                      </p>
                    
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default SignatureCard;
